import classnames from 'classnames';
import React from 'react';
import { IconRenderer } from "../../../helper/components/IconRenderer.js";
import { IconButton } from "../../iconButton/IconButton.js";
import styles from "./GenericToolbarItem.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function GenericToolbarItem({
  icon,
  on,
  action,
  disabled,
  title
}) {
  return /*#__PURE__*/_jsx(IconButton, {
    className: classnames(styles.item, {
      [styles.active]: on
    }),
    onClick: action,
    disabled: disabled,
    title: title,
    toolbar: true,
    tertiary: true,
    children: /*#__PURE__*/_jsx(IconRenderer, {
      icon: icon
    })
  });
}